import { render, staticRenderFns } from "./NewsRoute.vue?vue&type=template&id=429f53e5&scoped=true&"
import script from "./NewsRoute.vue?vue&type=script&lang=js&"
export * from "./NewsRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429f53e5",
  null
  
)

export default component.exports